import styled, { css } from 'styled-components';

export const FooterContainer = styled.div<{ hasClear: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;

  ${({ hasClear }) =>
    hasClear &&
    css`
      @media (max-width: 767px) {
        justify-content: space-between;
      }
    `}
`;
